'use client';

import { useTranslations } from 'next-intl';

import ReferralLink from '@/components/global/ReferralLink';
import { H4 } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';
import { profileInfo } from '@/ts/constants/C_Profile';

import NoDataWrapper from '../SectionWrapper/NoDataWrapper';

function ReferralsWrapper() {
  const t = useTranslations();

  const sectionInfo = profileInfo['referrals' as keyof typeof profileInfo];
  const isEmptyState = true; // Referrals data should come from real API

  return (
    <div className="flex md:flex-row gap-11 !flex-col">
      <div className={'flex-1 h-fit relative top-4'}>
        {/* Info cards will be shown when real data is available */}
      </div>

      <div className="flex-1">
        <div className="mb-24">
          {isEmptyState ? (
            <NoDataWrapper
              emptyState={{
                title: t(sectionInfo.emptyState.titleKey),
                text: t(sectionInfo.emptyState.textKey),
                actionText: sectionInfo.emptyState.actionTextKey
                  ? t(sectionInfo.emptyState.actionTextKey)
                  : ''
              }}
              variant="referrals"
            />
          ) : (
            <>
              <div className="flex flex-col gap-4 mb-5">
                <H4 className="justify-center text-center">
                  {t('profile.sections.referrals.content.title')}
                </H4>
              </div>

              <div className="max-w-[32rem] mx-auto">
                <div className="flex flex-col gap-4 overflow-y-auto max-h-none md:max-h-[75rem]">
                  {/* Referrals list will be shown when real data is available */}
                </div>
                <div className="fixed bottom-10 left-0 z-10 w-full px-4 md:static md:px-0">
                  <ReferralLink />
                </div>
                <Button className="w-full mt-5">
                  {t('profile.actions.viewAll')}
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReferralsWrapper;
